<router-outlet></router-outlet>
@if (loading$ | async) {
  <div class="leonus-loading-shade">
    <mat-spinner></mat-spinner>
  </div>
}
